
import { buildUrl, handleRequest, handlePublicRequest } from '@common/services/requestHelper';
import { RequestType } from '@common/services/types';
import { Id, IUploadResult } from '@common/types';

const basePath = process.env.REACT_APP_API_PATH;

const fetchBroadcastRecipients = async () => {
  const url = buildUrl(`/broadcast-recipient`, basePath);
  return handleRequest({ url, requestType: RequestType.GET });
};

const addBroadcastRecipient = async (emails: string[]) => {
  const url = buildUrl(`/broadcast-recipient`, basePath);
  return handleRequest({ url, requestType: RequestType.POST, data: { emails } });
};

const uploadBroadcastRecipientsCsv = async (formData: FormData): Promise<IUploadResult> => {
  const url = buildUrl(`/broadcast-recipient/upload-bulk`, basePath);
  return handleRequest({ url, requestType: RequestType.POST, data: formData });
};

const removeBroadcastRecipient = async (recipientId: Id) => {
  const url = buildUrl(`/broadcast-recipient/${recipientId}`, basePath);
  return handleRequest({ url, requestType: RequestType.DELETE });
};

const sendOptInRequest = async (recipientId: Id) => {
  const url = buildUrl(`/broadcast-recipient/${recipientId}/request-opt-in`, basePath);
  return handleRequest({ url, requestType: RequestType.POST });
};

const sendBroadcast = async (taskId: Id, recipientIds: Id[]) => {
  const url = buildUrl(`/broadcast/${taskId}/send`, basePath);
  return handleRequest({ url, requestType: RequestType.POST, data: { recipientIds } });
};

const fetchBroadcastPreview = async (taskId: Id): Promise<string> => {
  const url = buildUrl(`/broadcast/${taskId}/preview`, basePath);
  const response = await handleRequest({ url, requestType: RequestType.GET });
  return response as string;
};

const publicOptIn = async (token: string): Promise<void> => {
  const url = buildUrl(`/broadcast-recipient/${token}/opt-in`, basePath);
  return handlePublicRequest({ url, requestType: RequestType.PUT });
};

const publicOptOut = async (token: string): Promise<void> => {
  const url = buildUrl(`/broadcast-recipient/${token}/opt-out`, basePath);
  return handlePublicRequest({ url, requestType: RequestType.PUT });
};

const publicResendOptIn = async (token: string): Promise<void> => {
  const url = buildUrl(`/broadcast-recipient/${token}/request-opt-in-by-token`, basePath);
  return handlePublicRequest({ url, requestType: RequestType.POST });
};

export {
  fetchBroadcastRecipients,
  addBroadcastRecipient,
  uploadBroadcastRecipientsCsv,
  removeBroadcastRecipient,
  sendOptInRequest,
  sendBroadcast,
  fetchBroadcastPreview,
  publicOptOut,
  publicOptIn,
  publicResendOptIn,
};
